import { render } from "./CrearGrupos.vue?vue&type=template&id=6865098b"
import script from "./CrearGrupos.vue?vue&type=script&lang=js"
export * from "./CrearGrupos.vue?vue&type=script&lang=js"

import "./CrearGrupos.vue?vue&type=style&index=0&id=6865098b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__